import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { List, ListItem, ListItemText, Divider, Select, MenuItem, InputLabel, FormControl, Paper } from '@mui/material'
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { actualizarEvaluacion } from '../../Redux/evaluaciones';
import TokenContext from '../../context/TokenContext';

const ModalEncuesta = ({ open, handleClose, evaluacionPendiente, idEvaluacion }) => {
    const dispatch = useDispatch()
    const theme = useTheme();
    const token = useContext(TokenContext)
    const [fullWidth, setFullWidth] = React.useState(true);
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [maxWidth, setMaxWidth] = React.useState('lg');

    const [valoracion, setValoracion] = React.useState('');
    const [cualitativo, setCualitativo] = React.useState('');

    // Verificar si vacacion es un arreglo y obtener el primer elemento
    const evaluacionData = Array.isArray(evaluacionPendiente) ? evaluacionPendiente[0] : evaluacionPendiente;
    // Destructuring
    const { new_evaluado, _new_periodo_value, new_modalidad, _new_materia_value, new_seccion, statuscode, new_evaluador, createdon } = evaluacionData || {};

    //handler de la valoracion final
    const handleChange = (event) => {
        let value = event.target.value;
        value = Math.min(Math.max(parseInt(value), 1), 10);
        setValoracion(value);
    };

    const handleEnviar = () => {
        dispatch(actualizarEvaluacion(token, idEvaluacion, valoracion, cualitativo, []))
    }

    return (
        <Dialog
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            open={open}
            onClose={handleClose}

        >
            <DialogContent>
                <Paper elevation={3} sx={{ p: 4 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField label="Evaluador" value={new_evaluador} fullWidth multiline />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField label="Evaluado" value={new_evaluado} fullWidth multiline />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField label="Fecha de creación" value={createdon} fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField label="Razón para el estado" value={statuscode} fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField label="Periodo" value={_new_periodo_value} fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField label="Modalidad" value={new_modalidad} fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField label="Materia" value={_new_materia_value} fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField label="Sección" value={new_seccion} fullWidth />
                        </Grid>

                    </Grid>
                </Paper>

                <Box sx={{ mt: 2 }}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                        Cátedra asociada
                    </Typography>
                </Box>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Valoración (1-10)"
                            type="number"
                            fullWidth
                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', min: 1, max: 10 }}
                            value={valoracion}
                            onChange={handleChange}
                            variant="standard"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="outlined-multiline-flexible"
                            label="Cualitativo"
                            multiline
                            fullWidth
                            maxRows={4}
                            variant="standard"
                            onChange={(event) => setCualitativo(event.target.value)}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ p: '1.25rem' }}>
                <Box sx={{ p: 2, textAlign: 'right' }}>
                    <Button variant="text" color="secondary" onClick={handleClose}>
                        Cerrar
                    </Button>
                    <Button variant="contained" color="primary" onClick={handleEnviar}>
                        Enviar
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}

export default ModalEncuesta